module.exports = __webpack_public_path__ + "static/media/52.d353c6b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/52.jpg
// module id = 585
// module chunks = 0